export const setupAccessibilityWidget = (store) => {
  if (store.getters['auth/config']?.settings?.accessibility_widget_enabled) {
    if (!document.querySelector('script[src="https://widget.accessgo.de/accessGoWidget.js"]')) {
      const accessGoWidgetScript = document.createElement('script')
      accessGoWidgetScript.src = 'https://widget.accessgo.de/accessGoWidget.js'
      accessGoWidgetScript.type = 'module'
      document.head.appendChild(accessGoWidgetScript)
      setTimeout(() => {
        const widget = document.querySelector('ago-accessibility-widget')
        if (widget && widget.shadowRoot) {
          const style = document.createElement('style')
          style.textContent = `
            ago-accessibility-button {
              bottom: 65px !important;
            }
          `
          widget.shadowRoot.appendChild(style)

          const documentStyle = document.createElement('style')
          documentStyle.textContent = `
            ago-accessibility-widget {
              z-index: 3 !important;
            }
          `
          document.body.appendChild(documentStyle)
        }
      }, 1000)
    }
  }
}
